import React from 'react';
import { Helmet } from 'react-helmet';
import Components from './components.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { StaticQuery, graphql } from 'gatsby';

const Page = (props) => {
  // If the user is editing the navigation items in Storyblok from the "global-navi" item,
  // use that as the source for items. Otherwise, pull it from the StaticQuery

  let naviItems = [];
  if (
    props.data &&
    props.data.stories &&
    props.data.stories.edges &&
    props.data.stories.edges[0].node
  ) {
    naviItems = JSON.parse(props.data.stories.edges[0].node.content).nav_items;
  }

  return (
    <>
      <Helmet>
        {props.blok.title_override && <title>{props.blok.title_override} - Swell Energy</title>}
        {props.blok.title_override && (
          <meta property="og:title" content={`${props.blok.title_override} - Swell Energy`} />
        )}
        {props.blok.title_override && (
          <meta name="twitter:title" content={`${props.blok.title_override} - Swell Energy`} />
        )}
      </Helmet>
      {props.blok.body &&
        props.blok.body.map((blok) =>
          React.createElement(Components(blok.component), {
            key: blok._uid,
            blok: blok,
            powerProData: props.blok,
            naviItems,
          })
        )}
    </>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        stories: allStoryblokEntry(filter: { slug: { eq: "global-navi" } }) {
          edges {
            node {
              id
              name
              created_at
              uuid
              slug
              field_component
              full_slug
              content
              is_startpage
              parent_id
              group_id
            }
          }
        }
      }
    `}
    render={(data) => <Page data={data} {...props} />}
  />
);
